import { instance } from '@/apis/core';

import { GetCustomerResponse, GetLatestAddressResponse } from './types';

interface CustomerRepositoryImpl {
  get(): Promise<GetCustomerResponse>;
  address(): Promise<GetLatestAddressResponse>;
}

class CustomerRepository implements CustomerRepositoryImpl {
  get = async (): Promise<GetCustomerResponse> => {
    const { data } = await instance.get('/customer');
    return data;
  };
  address = async (): Promise<GetLatestAddressResponse> => {
    const { data } = await instance.get('/customer/latest-address');
    return data;
  };
}

export const customer = new CustomerRepository();
